// extracted by mini-css-extract-plugin
module.exports = {"container":"graph-pager_container__SEbFj","arrow":"graph-pager_arrow__p-7Y3"};